import type { PatientMonitoringBlock, PatientDatesBlock } from '../../../../services/patientCard';
import { Card, DateField, DotValueField, ValueField } from '../shared';

const STATUS_STYLES = {
    active: { dot: 'bg-emerald-500', text: 'text-emerald-700' },
    started: { dot: 'bg-emerald-500', text: 'text-emerald-700' },
    paused: { dot: 'bg-amber-500', text: 'text-amber-700' },
    stopped: { dot: 'bg-red-500', text: 'text-red-700' },
    resumed: { dot: 'bg-blue-500', text: 'text-blue-700' }
};

const ACTIVATION_STYLES = {
    'patient app activated': { dot: 'bg-emerald-500', text: 'text-emerald-700' },
    'patient app not activated': { dot: 'bg-red-500', text: 'text-red-700' }
};

interface MonitoringCardProps {
    monitoring: PatientMonitoringBlock | undefined;
    dates: PatientDatesBlock | undefined;
}

function MonitoringCard({ monitoring, dates }: MonitoringCardProps) {
    return (
        <Card title="Monitoring">
            <div className="grid grid-cols-2 gap-4">
                <DotValueField
                    label="Status"
                    value={monitoring?.monitoringStatus}
                    styles={STATUS_STYLES}
                />
                <DotValueField
                    label="App activation"
                    value={monitoring?.dmAppActivationStatus}
                    styles={ACTIVATION_STYLES}
                />
                <ValueField label="Quickstart type" value={monitoring?.quickstartType} />
                <ValueField label="Scan frequency" value={monitoring?.dmScanFrequency} />
                <DateField label="Last scan" value={dates?.scansDate ?? null} />
                <ValueField label="Activation count" value={monitoring?.dmLinkActivationCount} />
            </div>
        </Card>
    );
}

export { MonitoringCard };
